import TabNav from './src/TabNav';

/* istanbul ignore next */
TabNav.install = function(Vue) {
  Vue.component(TabNav.name, TabNav);
};

export default TabNav;
